var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 583.862,
    height: 301.533,
    viewBox: "0 0 583.862 301.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 87 28"
  }, /*#__PURE__*/React.createElement("image", {
    width: 87,
    height: 28,
    xlinkHref: "data:image/png;base64,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"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_134976",
    "data-name": "Group 134976",
    transform: "translate(-604.069 -4069.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134975",
    "data-name": "Group 134975",
    transform: "translate(536.646 3991.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134918",
    "data-name": "Group 134918",
    transform: "translate(282.981 78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134911",
    "data-name": "Group 134911",
    transform: "translate(31.615)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15491",
    "data-name": "Ellipse 15491",
    cx: 42.062,
    cy: 42.062,
    r: 42.062,
    transform: "translate(4.436 4.436)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15492",
    "data-name": "Ellipse 15492",
    cx: 42.062,
    cy: 42.062,
    r: 42.062,
    fill: "#ffb54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505305",
    "data-name": "Path 505305",
    d: "M359.56,157.049a33.876,33.876,0,1,1,33.877-33.876A33.914,33.914,0,0,1,359.56,157.049Zm0-65.557a31.681,31.681,0,1,0,31.681,31.681A31.717,31.717,0,0,0,359.56,91.492Z",
    transform: "translate(-317.498 -81.028)",
    fill: "#fcf0e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134910",
    "data-name": "Group 134910",
    transform: "translate(28.079 20.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134909",
    "data-name": "Group 134909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505306",
    "data-name": "Path 505306",
    d: "M364.372,142.847a24.008,24.008,0,0,1-6.119-1.585,23.278,23.278,0,0,1-5.388-3.048l3.8-5.557a29.21,29.21,0,0,0,3.876,2.51,14.735,14.735,0,0,0,4.072,1.438v-7.752a33.537,33.537,0,0,1-4.607-1.609,11.538,11.538,0,0,1-3.267-2.1,7.964,7.964,0,0,1-1.95-2.852,10.046,10.046,0,0,1-.658-3.779v-.1a9.084,9.084,0,0,1,.731-3.7,8.459,8.459,0,0,1,2.072-2.877,10.581,10.581,0,0,1,3.242-1.974,15.864,15.864,0,0,1,4.194-1v-2.828h5.071v2.925a20.362,20.362,0,0,1,9.068,3.608l-3.266,5.7a27.916,27.916,0,0,0-2.974-1.73A15.049,15.049,0,0,0,369.2,115.4v7.362q5.557,1.512,8.068,3.949a8.686,8.686,0,0,1,2.511,6.533v.1a8.833,8.833,0,0,1-.756,3.706,8.744,8.744,0,0,1-2.1,2.876,10.909,10.909,0,0,1-3.242,2,15.273,15.273,0,0,1-4.241,1.024v4.827h-5.071Zm.244-27.888a4.406,4.406,0,0,0-2.56,1.049,2.684,2.684,0,0,0-.8,1.975v.1a2.876,2.876,0,0,0,.683,1.926,6.53,6.53,0,0,0,2.682,1.536ZM369.2,136.85q3.46-.536,3.461-3.12v-.1a2.961,2.961,0,0,0-.731-2.072,7.046,7.046,0,0,0-2.73-1.536Z",
    transform: "translate(-352.865 -106.037)",
    fill: "#1b1b25"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134914",
    "data-name": "Group 134914",
    transform: "translate(31.615)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15493",
    "data-name": "Ellipse 15493",
    cx: 42.062,
    cy: 42.062,
    r: 42.062,
    transform: "translate(4.436 4.436)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15494",
    "data-name": "Ellipse 15494",
    cx: 42.062,
    cy: 42.062,
    r: 42.062,
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505307",
    "data-name": "Path 505307",
    d: "M359.56,157.049a33.876,33.876,0,1,1,33.877-33.876A33.914,33.914,0,0,1,359.56,157.049Zm0-65.557a31.681,31.681,0,1,0,31.681,31.681A31.717,31.717,0,0,0,359.56,91.492Z",
    transform: "translate(-317.498 -81.028)",
    fill: "#fcf0e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134917",
    "data-name": "Group 134917",
    transform: "translate(10.728 1.555)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15495",
    "data-name": "Ellipse 15495",
    cx: 19.032,
    cy: 19.032,
    r: 19.032,
    transform: "translate(2.007 2.007)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15496",
    "data-name": "Ellipse 15496",
    cx: 19.032,
    cy: 19.032,
    r: 19.032,
    fill: "#ffb54a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505309",
    "data-name": "Path 505309",
    d: "M306.35,115.893a15.329,15.329,0,1,1,15.328-15.328A15.346,15.346,0,0,1,306.35,115.893Zm0-29.663a14.335,14.335,0,1,0,14.334,14.335A14.351,14.351,0,0,0,306.35,86.23Z",
    transform: "translate(-287.318 -81.495)",
    fill: "#fcf0e3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505311",
    "data-name": "Path 505311",
    d: "M279.569,146.768h0A8.264,8.264,0,0,0,271.3,138.5h0a8.265,8.265,0,0,0,8.265-8.265h0a8.265,8.265,0,0,0,8.265,8.265h0A8.265,8.265,0,0,0,279.569,146.768Z",
    transform: "translate(-271.304 -92.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505312",
    "data-name": "Path 505312",
    d: "M413.031,205.149h0a6.07,6.07,0,0,0-6.07-6.07h0a6.07,6.07,0,0,0,6.07-6.07h0a6.07,6.07,0,0,0,6.07,6.07h0A6.07,6.07,0,0,0,413.031,205.149Z",
    transform: "translate(-307.673 -108.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505313",
    "data-name": "Path 505313",
    d: "M356.961,241.358h0A11.161,11.161,0,0,0,345.8,230.2h0a11.162,11.162,0,0,0,11.161-11.161h0A11.161,11.161,0,0,0,368.121,230.2h0A11.161,11.161,0,0,0,356.961,241.358Z",
    transform: "translate(-291.276 -115.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505314",
    "data-name": "Path 505314",
    d: "M409.865,124.214h0a10.46,10.46,0,0,0-10.46-10.46h0a10.46,10.46,0,0,0,10.46-10.459h0a10.459,10.459,0,0,0,10.459,10.459h0A10.459,10.459,0,0,0,409.865,124.214Z",
    transform: "translate(-305.648 -84.782)",
    fill: "#fcf0e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505315",
    "data-name": "Path 505315",
    d: "M459.353,137.3h0a5.769,5.769,0,0,0-5.769-5.77h0a5.769,5.769,0,0,0,5.769-5.77h0a5.77,5.77,0,0,0,5.77,5.77h0A5.77,5.77,0,0,0,459.353,137.3Z",
    transform: "translate(-320.173 -90.806)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134930",
    "data-name": "Group 134930",
    transform: "translate(67.423 101.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505316",
    "data-name": "Path 505316",
    d: "M209.184,115.229H130.431a14.666,14.666,0,0,0,0,29.331h64.9l8.929,8.136V144.56h4.922a14.666,14.666,0,0,0,0-29.331Z",
    transform: "translate(-72.405 -104.864)",
    fill: "#c91006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505317",
    "data-name": "Path 505317",
    d: "M138.7,128.381a4.649,4.649,0,1,0-5.936,0,8.617,8.617,0,0,0-5.654,8.086c0,4.762,17.245,4.762,17.245,0A8.617,8.617,0,0,0,138.7,128.381Z",
    transform: "translate(-73.574 -105.371)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134919",
    "data-name": "Group 134919",
    transform: "translate(80.886 17.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505318",
    "data-name": "Path 505318",
    d: "M214.481,123.916H158.05a.448.448,0,0,1,0-.9h56.431a.448.448,0,0,1,0,.9Z",
    transform: "translate(-157.602 -123.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505319",
    "data-name": "Path 505319",
    d: "M205.727,138.678H158.05a.448.448,0,0,1,0-.9h47.677a.448.448,0,0,1,0,.9Z",
    transform: "translate(-157.602 -124.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505320",
    "data-name": "Path 505320",
    d: "M192.744,131.764H158.05a.448.448,0,0,1,0-.9h34.693a.448.448,0,0,1,0,.9Z",
    transform: "translate(-157.602 -123.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505321",
    "data-name": "Path 505321",
    d: "M218.964,131.764H201.552a.448.448,0,1,1,0-.9h17.412a.448.448,0,1,1,0,.9Z",
    transform: "translate(-162.085 -123.828)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505322",
    "data-name": "Path 505322",
    d: "M142.4,135.682a1.34,1.34,0,0,1-.951-.395l-3.38-3.38a1.345,1.345,0,0,1,1.9-1.9l2.428,2.429,6.525-6.525a1.345,1.345,0,1,1,1.9,1.9l-7.476,7.476A1.342,1.342,0,0,1,142.4,135.682Z",
    transform: "translate(-74.663 -105.924)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134925",
    "data-name": "Group 134925",
    transform: "translate(472.97 86.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505323",
    "data-name": "Path 505323",
    d: "M609.779,200.38h80.8a15.047,15.047,0,1,1,0,30.094H623.99l-9.161,8.348v-8.348h-5.05a15.047,15.047,0,1,1,0-30.094Z",
    transform: "translate(-594.732 -200.38)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134923",
    "data-name": "Group 134923",
    transform: "translate(82.447 4.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134922",
    "data-name": "Group 134922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134921",
    "data-name": "Group 134921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505324",
    "data-name": "Path 505324",
    d: "M698.241,213.745a4.65,4.65,0,1,0-5.936,0,8.617,8.617,0,0,0-5.654,8.086c0,4.762,17.244,4.762,17.244,0A8.616,8.616,0,0,0,698.241,213.745Z",
    transform: "translate(-686.651 -205.517)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134920",
    "data-name": "Group 134920",
    transform: "translate(10.873 8.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505325",
    "data-name": "Path 505325",
    d: "M706.571,217.268h-2.227v-2.227a.437.437,0,0,0-.438-.438h-2.032a.438.438,0,0,0-.438.438v2.227h-2.226a.437.437,0,0,0-.438.437v2.032a.437.437,0,0,0,.438.437h2.226V222.4a.438.438,0,0,0,.438.437h2.032a.437.437,0,0,0,.438-.437v-2.227h2.227a.437.437,0,0,0,.437-.437V217.7A.437.437,0,0,0,706.571,217.268Z",
    transform: "translate(-698.773 -214.603)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134924",
    "data-name": "Group 134924",
    transform: "translate(18.511 8.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505326",
    "data-name": "Path 505326",
    d: "M672.248,210.28h-56.43a.448.448,0,1,1,0-.9h56.43a.448.448,0,1,1,0,.9Z",
    transform: "translate(-615.37 -209.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505327",
    "data-name": "Path 505327",
    d: "M663.493,225.042H615.818a.448.448,0,0,1,0-.9h47.675a.448.448,0,0,1,0,.9Z",
    transform: "translate(-615.37 -210.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505328",
    "data-name": "Path 505328",
    d: "M650.511,218.128H615.818a.448.448,0,1,1,0-.9h34.692a.448.448,0,1,1,0,.9Z",
    transform: "translate(-615.37 -210.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505329",
    "data-name": "Path 505329",
    d: "M676.731,218.128H659.319a.448.448,0,0,1,0-.9h17.412a.448.448,0,1,1,0,.9Z",
    transform: "translate(-619.853 -210.192)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134927",
    "data-name": "Group 134927",
    transform: "translate(376.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505330",
    "data-name": "Path 505330",
    d: "M497.086,103.673h55.659a10.365,10.365,0,1,1,0,20.73H497.086a10.365,10.365,0,1,1,0-20.73Z",
    transform: "translate(-486.721 -103.673)",
    fill: "#c91006"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134926",
    "data-name": "Group 134926",
    transform: "translate(16.139 6.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505331",
    "data-name": "Path 505331",
    d: "M548.317,111.325H505.162a.448.448,0,0,1,0-.9h43.154a.448.448,0,1,1,0,.9Z",
    transform: "translate(-504.714 -110.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505332",
    "data-name": "Path 505332",
    d: "M541.622,120.067H505.162a.448.448,0,0,1,0-.9h36.459a.448.448,0,1,1,0,.9Z",
    transform: "translate(-504.714 -111.329)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505333",
    "data-name": "Path 505333",
    d: "M531.693,115.972H505.162a.448.448,0,0,1,0-.9h26.531a.448.448,0,0,1,0,.9Z",
    transform: "translate(-504.714 -110.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505334",
    "data-name": "Path 505334",
    d: "M551.745,115.972H538.429a.448.448,0,0,1,0-.9h13.315a.448.448,0,1,1,0,.9Z",
    transform: "translate(-508.142 -110.907)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134929",
    "data-name": "Group 134929",
    transform: "translate(0 146.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505335",
    "data-name": "Path 505335",
    d: "M76.639,267.5H126.13a9.217,9.217,0,1,1,0,18.433H76.639a9.217,9.217,0,0,1,0-18.433Z",
    transform: "translate(-67.423 -267.504)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134928",
    "data-name": "Group 134928",
    transform: "translate(14.301 5.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505336",
    "data-name": "Path 505336",
    d: "M122.187,274.352H83.815a.448.448,0,1,1,0-.9h38.372a.448.448,0,1,1,0,.9Z",
    transform: "translate(-83.367 -273.455)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505337",
    "data-name": "Path 505337",
    d: "M116.234,282.125H83.815a.448.448,0,1,1,0-.9h32.419a.448.448,0,1,1,0,.9Z",
    transform: "translate(-83.367 -274.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505338",
    "data-name": "Path 505338",
    d: "M107.405,278.484H83.815a.448.448,0,1,1,0-.9h23.59a.448.448,0,1,1,0,.9Z",
    transform: "translate(-83.367 -273.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505339",
    "data-name": "Path 505339",
    d: "M125.235,278.484H113.4a.448.448,0,1,1,0-.9h11.84a.448.448,0,1,1,0,.9Z",
    transform: "translate(-86.415 -273.881)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134933",
    "data-name": "Group 134933",
    transform: "translate(254.598 296.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134931",
    "data-name": "Group 134931",
    transform: "translate(99.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505340",
    "data-name": "Path 505340",
    d: "M475.362,322.963H387.428a.448.448,0,1,1,0-.9h87.933a.448.448,0,0,1,0,.9Z",
    transform: "translate(-386.98 -322.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505341",
    "data-name": "Path 505341",
    d: "M476.929,345.967H402.637a.448.448,0,0,1,0-.9h74.292a.448.448,0,0,1,0,.9Z",
    transform: "translate(-388.547 -324.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505342",
    "data-name": "Path 505342",
    d: "M479.254,335.193h-54.06a.448.448,0,1,1,0-.9h54.06a.448.448,0,0,1,0,.9Z",
    transform: "translate(-390.872 -323.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505343",
    "data-name": "Path 505343",
    d: "M414.559,335.193H387.428a.448.448,0,1,1,0-.9h27.131a.448.448,0,1,1,0,.9Z",
    transform: "translate(-386.98 -323.326)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134932",
    "data-name": "Group 134932",
    transform: "translate(0 32.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505344",
    "data-name": "Path 505344",
    d: "M364.484,359.453H276.55a.448.448,0,0,1,0-.9h87.934a.448.448,0,0,1,0,.9Z",
    transform: "translate(-276.102 -358.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505345",
    "data-name": "Path 505345",
    d: "M350.841,382.456H276.55a.448.448,0,0,1,0-.9h74.291a.448.448,0,0,1,0,.9Z",
    transform: "translate(-276.102 -360.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505346",
    "data-name": "Path 505346",
    d: "M330.611,371.682H276.55a.448.448,0,0,1,0-.9h54.06a.448.448,0,0,1,0,.9Z",
    transform: "translate(-276.102 -359.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505347",
    "data-name": "Path 505347",
    d: "M371.469,371.682H344.337a.448.448,0,0,1,0-.9h27.132a.448.448,0,0,1,0,.9Z",
    transform: "translate(-283.087 -359.816)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134955",
    "data-name": "Group 134955",
    transform: "translate(365.156 137.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134939",
    "data-name": "Group 134939",
    transform: "translate(0 14.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134938",
    "data-name": "Group 134938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134937",
    "data-name": "Group 134937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134935",
    "data-name": "Group 134935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505348",
    "data-name": "Path 505348",
    d: "M443.482,255.653l.03-.1L456.5,210.374l-.057-.043a16.229,16.229,0,0,1,5.2-5.755,15.039,15.039,0,0,0,5.993-9.921c2.859-2.766,6.08-5.127,9-7.83a2.074,2.074,0,0,0,.711-1,1.74,1.74,0,0,0-.37-1.3c-1.507-2.233-4.276-2.555-6.578-1.524a16.083,16.083,0,0,0-3.686,2.407,18.345,18.345,0,0,0-2.922,2.5l10.33-22.056c.917-1.958.317-4.193-1.334-4.966h0a3.07,3.07,0,0,0-2.609.053,4.155,4.155,0,0,0-1.437,1.145l.05-.257c-12.1-10.173-27.026,24.454-27.026,24.454l-4.237,10L401.589,262.9a19.357,19.357,0,0,0,8.652,26.405h0c.142.069.284.129.426.195a19.513,19.513,0,0,0,9.787,2.619h70.716l15.238-36.216Zm20.147-67.409Z",
    transform: "translate(-399.362 -159.959)",
    fill: "#fec29e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134934",
    "data-name": "Group 134934",
    transform: "translate(30.755 95.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505349",
    "data-name": "Path 505349",
    d: "M446.082,274.512l-1.81,6.3C444.929,278.632,445.547,276.5,446.082,274.512Z",
    transform: "translate(-434.745 -267.354)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505350",
    "data-name": "Path 505350",
    d: "M434.9,307.283Z",
    transform: "translate(-433.651 -270.727)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505351",
    "data-name": "Path 505351",
    d: "M435.063,307.287l.579.018Z",
    transform: "translate(-433.796 -270.732)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505352",
    "data-name": "Path 505352",
    d: "M447.257,266.532,445.2,273.69c-.535,1.987-1.153,4.12-1.81,6.3l-2.486,8.65a19.492,19.492,0,0,1-1.289,3.155c-2.14,6.4-3.905,11.313-3.905,11.313l25.431-36.414C454.814,266.691,453.363,266.539,447.257,266.532Z",
    transform: "translate(-433.863 -266.532)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505353",
    "data-name": "Path 505353",
    d: "M435.049,307.287h0Z",
    transform: "translate(-433.795 -270.732)",
    fill: "#ff887c",
    opacity: 0.17
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505354",
    "data-name": "Path 505354",
    d: "M459.947,193.13a.448.448,0,0,1-.361-.715,8.218,8.218,0,0,1,10.641-2.78.448.448,0,0,1-.439.782c-.221-.122-5.444-2.943-9.481,2.53A.445.445,0,0,1,459.947,193.13Z",
    transform: "translate(-405.559 -162.922)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505355",
    "data-name": "Path 505355",
    d: "M475.952,162.185a68.451,68.451,0,0,0-5.136,7.39,33.5,33.5,0,0,0-2.041,3.974,9.787,9.787,0,0,0-.961,4.175l0,.028a.449.449,0,0,1-.9.048v-.011a10.506,10.506,0,0,1,1.114-4.558A34.252,34.252,0,0,1,470.2,169.2a69.19,69.19,0,0,1,5.337-7.359.268.268,0,0,1,.416.336Z",
    transform: "translate(-406.324 -160.143)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505356",
    "data-name": "Path 505356",
    d: "M472.368,160.75a16.858,16.858,0,0,0-3.2,3.014,26.794,26.794,0,0,0-2.54,3.635,32.3,32.3,0,0,0-1.939,4c-.293.681-.512,1.392-.771,2.085l-.643,2.129-.008.026a.448.448,0,1,1-.858-.259l0-.008.7-2.165c.279-.706.517-1.427.83-2.119a32.875,32.875,0,0,1,2.065-4.055,27.464,27.464,0,0,1,2.677-3.682,17.343,17.343,0,0,1,3.395-3.072.278.278,0,0,1,.311.461Z",
    transform: "translate(-405.857 -159.987)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505357",
    "data-name": "Path 505357",
    d: "M467.076,161.141a43.708,43.708,0,0,0-4.7,5.8,24.878,24.878,0,0,0-1.851,3.212A13.141,13.141,0,0,0,459.4,173.6l0,.011a.449.449,0,1,1-.886-.14l0-.011a13.951,13.951,0,0,1,1.3-3.658,25.7,25.7,0,0,1,1.988-3.261,44.211,44.211,0,0,1,4.915-5.774.261.261,0,0,1,.374.365Z",
    transform: "translate(-405.457 -160.035)",
    fill: "#fb8e77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134936",
    "data-name": "Group 134936",
    transform: "translate(63.128 95.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505358",
    "data-name": "Path 505358",
    d: "M613.946,332.412,596.6,285.127c-2.065-10.376-11.936-18.241-23.81-18.241l-48.455-.386-54.591.208V303.1h16.942l-8.744,94.921,120.21.68-.674-64.276Z",
    transform: "translate(-469.743 -266.5)",
    fill: "#eb4239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505359",
    "data-name": "Path 505359",
    d: "M497.381,337.332",
    transform: "translate(-472.591 -273.799)",
    fill: "none",
    stroke: "#fb8e77",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505360",
    "data-name": "Path 505360",
    d: "M524.239,266.905l.1-.405-54.591.208V303.1h16.942l.089-.961C486.773,282.934,503.471,267.326,524.239,266.905Z",
    transform: "translate(-406.615 -170.938)",
    fill: "#1b1b25",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505361",
    "data-name": "Path 505361",
    d: "M453.584,208.238s3.064,26.024,3.244,25.4l5.257-18.287Z",
    transform: "translate(-404.95 -164.934)",
    fill: "#ff887c",
    opacity: 0.18
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134942",
    "data-name": "Group 134942",
    transform: "translate(86.638 145.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134940",
    "data-name": "Group 134940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505362",
    "data-name": "Path 505362",
    d: "M529.506,350.064l-4.588-23.122L521.379,309.1a3.9,3.9,0,0,0-4.573-3.058l-17.719,3.515a3.9,3.9,0,0,0-3.059,4.573l3.562,17.955,2.826,14.242,1.738,8.764a3.9,3.9,0,0,0,4.573,3.059l10.467-2.076,7.254-1.44A3.9,3.9,0,0,0,529.506,350.064Z",
    transform: "translate(-495.954 -305.97)",
    fill: "#1b1b25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134941",
    "data-name": "Group 134941",
    transform: "translate(0.757 20.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505363",
    "data-name": "Path 505363",
    d: "M623.914,373.782l-7.991-34.795-36.33,4.444,1.995,8.851-.185-.046-39.494-9.778-.034.048a13.226,13.226,0,0,1-4.938-4.539,11.821,11.821,0,0,0-8.874-5.085c-1.072-1.123-2.07-2.323-3.058-3.534l.926,4.664-.231.122a14.959,14.959,0,0,1-8.177,1.7l-17.365-1.355a2.643,2.643,0,0,0-2.6,1.477c-5.083,10.684,16.741,20.46,21.721,22.527h0l.175.072.2.084.19.076.159.065.149.058.057.022.074.029,8.542,3.2,67.617,33.282a19.607,19.607,0,0,0,1.9.791,16.875,16.875,0,0,0,10.84,1.12h0A19.612,19.612,0,0,0,623.914,373.782Z",
    transform: "translate(-496.798 -329.351)",
    fill: "#fec29e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505364",
    "data-name": "Path 505364",
    d: "M630.85,364.183,589.1,345.05c1.394,6.071.582,3.392,1.81,8.805l2.841.7C605.777,355.369,630.85,364.183,630.85,364.183Z",
    transform: "translate(-506.31 -330.969)",
    fill: "#ff887c",
    opacity: 0.17
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505365",
    "data-name": "Path 505365",
    d: "M584.693,342.545a.448.448,0,0,1-.439-.358l-5.216-25.265a.448.448,0,0,1,.878-.182l5.132,24.859,17.567-2.235a.449.449,0,1,1,.114.89l-17.979,2.288A.412.412,0,0,1,584.693,342.545Z",
    transform: "translate(-504.515 -307.043)",
    fill: "#1b1b25",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134943",
    "data-name": "Group 134943",
    transform: "translate(211.935 199.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505366",
    "data-name": "Path 505366",
    d: "M635.963,367.984l.071.358Z",
    transform: "translate(-635.679 -366.546)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505367",
    "data-name": "Path 505367",
    d: "M636.042,368.383Z",
    transform: "translate(-635.687 -366.587)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505368",
    "data-name": "Path 505368",
    d: "M635.646,366.381s.1.488.189.959C635.785,367.084,635.725,366.782,635.646,366.381Z",
    transform: "translate(-635.646 -366.381)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505369",
    "data-name": "Path 505369",
    d: "M635.857,367.45l.1.479C635.924,367.787,635.891,367.621,635.857,367.45Z",
    transform: "translate(-635.668 -366.491)",
    fill: "#ff887c",
    opacity: 0.17
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134954",
    "data-name": "Group 134954",
    transform: "translate(97.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134945",
    "data-name": "Group 134945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505370",
    "data-name": "Path 505370",
    d: "M573.3,160.612a14.289,14.289,0,0,0-21.362-10.3,12.584,12.584,0,0,0-19.519-2.5,16.611,16.611,0,0,0-18.412,27.322l-3.378,18.045a9.541,9.541,0,0,0,7.623,11.135l40.026,7.493a9.543,9.543,0,0,0,11.135-7.624l6.558-35.028A9.532,9.532,0,0,0,573.3,160.612Z",
    transform: "translate(-508.368 -144.259)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134944",
    "data-name": "Group 134944",
    transform: "translate(3.612 7.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505371",
    "data-name": "Path 505371",
    d: "M515.376,171.317a.451.451,0,0,1-.379-.209c-7.15-11.314,2.7-18.57,2.8-18.641a.448.448,0,0,1,.523.728c-.381.274-9.255,6.844-2.563,17.434a.448.448,0,0,1-.379.688Z",
    transform: "translate(-512.395 -152.382)",
    fill: "#fcf0e3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134947",
    "data-name": "Group 134947",
    transform: "translate(1.05 30.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134946",
    "data-name": "Group 134946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505372",
    "data-name": "Path 505372",
    d: "M566.945,199.464l-.875-.164-8.836-18.991A14.3,14.3,0,0,1,551.255,178a10.759,10.759,0,0,1-15.189.638,16.594,16.594,0,0,1-20.061,1.414l-6.155,32.878a18.107,18.107,0,0,0,2.281,12.671,18.392,18.392,0,0,0,12.942,11.052v21.711a13.753,13.753,0,0,0,13.713,13.713h4.326a13.753,13.753,0,0,0,13.713-13.713V233.709a18.315,18.315,0,0,0,4.486-8.988l1.124-6,.875.164a9.638,9.638,0,0,0,11.214-7.677l.1-.527A9.637,9.637,0,0,0,566.945,199.464Z",
    transform: "translate(-509.539 -177.998)",
    fill: "#fec29e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505373",
    "data-name": "Path 505373",
    d: "M560.7,222.547l-.8,4.283a18.2,18.2,0,0,1-21.238,14.54l-13.968-2.615a18.134,18.134,0,0,1-12.26-8.567,18.4,18.4,0,0,0,13.69,11.232l.557.1a13.742,13.742,0,0,0,12.346,7.8H543.4a13.756,13.756,0,0,0,13.34-10.6,18.328,18.328,0,0,0,4.865-9.411l1.124-6Z",
    transform: "translate(-509.837 -182.589)",
    fill: "#ff887c",
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134953",
    "data-name": "Group 134953",
    transform: "translate(3.689 42.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505374",
    "data-name": "Path 505374",
    d: "M573.944,215.406a.45.45,0,0,1-.274-.094l-3.49-2.709a.451.451,0,0,1-.172-.333.446.446,0,0,1,.14-.348l4.3-4.062a.448.448,0,0,1,.614.653l-3.922,3.7,3.077,2.388a.449.449,0,0,1-.275.8Z",
    transform: "translate(-518.409 -192.851)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134952",
    "data-name": "Group 134952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134951",
    "data-name": "Group 134951",
    transform: "translate(4.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134950",
    "data-name": "Group 134950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134948",
    "data-name": "Group 134948",
    transform: "translate(20.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505375",
    "data-name": "Path 505375",
    d: "M548.7,197.006a5.317,5.317,0,0,1-2.06-.784c-.69-.373-1.392-.731-2.014-1.02s-1.349-.6-2.078-.888a5.275,5.275,0,0,1-1.92-1.072c-.429-.475-.344-1.223.658-1.724a6.08,6.08,0,0,1,4.963.34,5.9,5.9,0,0,1,3.4,3.558C549.881,196.5,549.343,197.032,548.7,197.006Z",
    transform: "translate(-540.38 -191.14)",
    fill: "#1b1b25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134949",
    "data-name": "Group 134949",
    transform: "translate(0 0.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505376",
    "data-name": "Path 505376",
    d: "M517.781,194.632a5.965,5.965,0,0,0,2.157.446c.781.067,1.565.152,2.243.248s1.458.228,2.228.378a5.938,5.938,0,0,0,2.192.163c.614-.137.936-.732.35-1.6a6.509,6.509,0,0,0-4.383-2.215,6.256,6.256,0,0,0-4.754.936C517.046,193.667,517.219,194.33,517.781,194.632Z",
    transform: "translate(-517.297 -191.966)",
    fill: "#1b1b25"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12309",
    "data-name": "Rectangle 12309",
    width: 2.281,
    height: 3.665,
    rx: 1.141,
    transform: "matrix(-0.983, -0.184, 0.184, -0.983, 27.897, 13.749)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12310",
    "data-name": "Rectangle 12310",
    width: 2.281,
    height: 3.665,
    rx: 1.141,
    transform: "matrix(-0.983, -0.184, 0.184, -0.983, 8.563, 10.607)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12311",
    "data-name": "Rectangle 12311",
    d: "M1.412,0H5.33A1.413,1.413,0,0,1,6.743,1.413v0A1.412,1.412,0,0,1,5.331,2.825H1.413A1.413,1.413,0,0,1,0,1.412v0A1.412,1.412,0,0,1,1.412,0Z",
    transform: "translate(32.878 19.273) rotate(-173.583)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12312",
    "data-name": "Rectangle 12312",
    d: "M1.413,0H5.332A1.411,1.411,0,0,1,6.743,1.411v0A1.413,1.413,0,0,1,5.33,2.826H1.412A1.412,1.412,0,0,1,0,1.413v0A1.413,1.413,0,0,1,1.413,0Z",
    transform: "matrix(-0.994, -0.112, 0.112, -0.994, 6.701, 15.15)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505377",
    "data-name": "Path 505377",
    d: "M526.848,229.82a.449.449,0,0,1-.265-.811,4.241,4.241,0,0,1,4.836-.005.449.449,0,0,1-.514.735,3.364,3.364,0,0,0-3.793-.006A.447.447,0,0,1,526.848,229.82Z",
    transform: "translate(-513.915 -194.964)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505378",
    "data-name": "Path 505378",
    d: "M530.281,215.615l10.49-1.5-1.149,3.643a5.6,5.6,0,0,1-5.344,3.919h0a3.723,3.723,0,0,1-3.7-3.326Z",
    transform: "translate(-514.315 -193.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505379",
    "data-name": "Path 505379",
    d: "M532.525,209.727a.449.449,0,0,1-.113-.015l-3.252-.846a4.575,4.575,0,0,1-2.848-6.649l4.952-8.915a.449.449,0,1,1,.785.435l-4.952,8.915A3.678,3.678,0,0,0,529.385,208l3.252.847a.449.449,0,0,1-.113.883Z",
    transform: "translate(-513.846 -191.339)",
    fill: "#fb8e77"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134974",
    "data-name": "Group 134974",
    transform: "translate(129.582 159.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134959",
    "data-name": "Group 134959",
    transform: "translate(6.952 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134958",
    "data-name": "Group 134958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134956",
    "data-name": "Group 134956",
    transform: "translate(120.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505380",
    "data-name": "Path 505380",
    d: "M354.778,271.71l-35.933-66.623-4.236-10s-14.928-34.627-27.026-24.453l.05.257a4.152,4.152,0,0,0-1.437-1.144,3.069,3.069,0,0,0-2.61-.053h0c-1.65.772-2.25,3.007-1.333,4.966l10.329,22.056a18.245,18.245,0,0,0-2.921-2.5,16.023,16.023,0,0,0-3.686-2.407c-2.3-1.031-5.072-.709-6.578,1.524a1.735,1.735,0,0,0-.37,1.3,2.074,2.074,0,0,0,.71,1c2.919,2.7,6.141,5.063,9,7.83a15.032,15.032,0,0,0,5.993,9.92,16.229,16.229,0,0,1,5.2,5.756l-.056.042,13.015,45.279-19.007.254v36.216h42.036a19.508,19.508,0,0,0,9.8-2.625c.138-.064.277-.121.414-.188h0A19.356,19.356,0,0,0,354.778,271.71Z",
    transform: "translate(-279.003 -168.69)",
    fill: "#fec29e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505381",
    "data-name": "Path 505381",
    d: "M326.706,311.911h0s-9.769-26.28-11.446-36.573c-6.472,0-7.456.288-13.929.288Z",
    transform: "translate(-281.304 -179.672)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505382",
    "data-name": "Path 505382",
    d: "M304.124,201.936a.447.447,0,0,1-.361-.182c-4.035-5.473-9.26-2.652-9.48-2.529a.449.449,0,0,1-.439-.783,8.22,8.22,0,0,1,10.64,2.78.449.449,0,0,1-.094.628A.444.444,0,0,1,304.124,201.936Z",
    transform: "translate(-280.509 -171.653)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505383",
    "data-name": "Path 505383",
    d: "M288.726,170.63a37.738,37.738,0,0,1,3.021,3.444,37.312,37.312,0,0,1,2.6,3.776,27.674,27.674,0,0,1,2.01,4.147,17.648,17.648,0,0,1,1.008,4.544.448.448,0,1,1-.894.07v-.025a16.866,16.866,0,0,0-.873-4.317,26.9,26.9,0,0,0-1.869-4.06,36.86,36.86,0,0,0-2.477-3.755,37.329,37.329,0,0,0-2.9-3.443l-.006-.006a.268.268,0,0,1,.382-.375Z",
    transform: "translate(-279.958 -168.874)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505384",
    "data-name": "Path 505384",
    d: "M292.112,168.712a11.816,11.816,0,0,1,3.537,3.066,24.292,24.292,0,0,1,2.579,3.843,39.794,39.794,0,0,1,1.988,4.166l.815,2.156.725,2.187a.448.448,0,1,1-.851.282l0-.005-.006-.021-.674-2.165-.762-2.135a38.668,38.668,0,0,0-1.871-4.117,23.6,23.6,0,0,0-2.438-3.785,11.423,11.423,0,0,0-3.256-2.958l-.042-.023a.277.277,0,0,1,.259-.49Z",
    transform: "translate(-280.312 -168.682)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505385",
    "data-name": "Path 505385",
    d: "M297.6,169.555a22.356,22.356,0,0,1,2.739,2.67,25.807,25.807,0,0,1,2.3,3.044,24.335,24.335,0,0,1,1.846,3.352,25.211,25.211,0,0,1,1.323,3.6.449.449,0,0,1-.859.257l0-.008-.006-.022a24.256,24.256,0,0,0-1.19-3.505,23.432,23.432,0,0,0-1.711-3.3,25.2,25.2,0,0,0-2.172-3.024,21.825,21.825,0,0,0-2.593-2.659l-.011-.01a.261.261,0,0,1,.333-.4Z",
    transform: "translate(-280.876 -168.766)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505386",
    "data-name": "Path 505386",
    d: "M300.463,221.92l13.886-1.714-8.586,17.08S303.207,224.585,300.463,221.92Z",
    transform: "translate(-281.214 -173.991)",
    fill: "#ff887c",
    opacity: 0.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134957",
    "data-name": "Group 134957",
    transform: "translate(0 95.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505387",
    "data-name": "Path 505387",
    d: "M228.589,275.716l0,.016c-.214-.005-.427-.016-.642-.016H184.073a22.282,22.282,0,0,0-20.835,14.392h0l-.066.182-.032.087-18.661,50.867,17.324,2.119v56.489h94.28l7.05-87.919h16.4V275.539Z",
    transform: "translate(-144.474 -275.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505388",
    "data-name": "Path 505388",
    d: "M289.832,275.539l-50.088.208v.006a35.251,35.251,0,0,1,33.764,35.218l-.077.961h16.4Z",
    transform: "translate(-154.291 -275.539)",
    fill: "#1b1b25",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505389",
    "data-name": "Path 505389",
    d: "M278.149,346.139",
    transform: "translate(-158.249 -282.814)",
    fill: "none",
    stroke: "#fb8e77",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134962",
    "data-name": "Group 134962",
    transform: "translate(0 131.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505390",
    "data-name": "Path 505390",
    d: "M272.58,318.366,254.86,314.85a3.9,3.9,0,0,0-4.573,3.059l-3.539,17.839L242.16,358.87a3.9,3.9,0,0,0,3.059,4.573l7.254,1.439,10.467,2.076a3.9,3.9,0,0,0,4.572-3.058l1.739-8.765,2.825-14.241,3.563-17.955A3.9,3.9,0,0,0,272.58,318.366Z",
    transform: "translate(-147.581 -314.776)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134961",
    "data-name": "Group 134961",
    transform: "translate(0 7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505391",
    "data-name": "Path 505391",
    d: "M263.58,344.584a2.575,2.575,0,0,0-.993-1.09c-.075-.111-.136-.222-.218-.334l-.424.053a2.666,2.666,0,0,0-.963-.107l-17.365,1.355a14.963,14.963,0,0,1-8.176-1.7l-.42-.222.87-4.383c-.938,1.149-1.889,2.284-2.9,3.356a12.136,12.136,0,0,0-6.171,2.328,11.136,11.136,0,0,0-2.862,2.934,14.183,14.183,0,0,1-3.211,3.448,11.057,11.057,0,0,1-1.484.91l-.034-.048-39.5,9.778-.182.045,2-8.892-36.34-4.4-7.991,34.795a19.611,19.611,0,0,0,14.725,23.5h0a16.866,16.866,0,0,0,10.839-1.119,19.741,19.741,0,0,0,1.9-.791l66.852-32.906,9.061-3.4s.367-.141,1.008-.407l-.133-.026C245.617,365.58,268.8,355.561,263.58,344.584Z",
    transform: "translate(-136.723 -324.685)",
    fill: "#fec29e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134960",
    "data-name": "Group 134960",
    transform: "translate(2.477 27.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505392",
    "data-name": "Path 505392",
    d: "M139.565,376.756c-.037.19-.06.306-.071.36Z",
    transform: "translate(-139.486 -356.175)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505393",
    "data-name": "Path 505393",
    d: "M179.815,362.658c.819-3.765.581-3.441,1.823-8.848l-41.755,19.175s4.138-1.246,9.847-2.761c.531-.193,1.071-.372,1.628-.522Z",
    transform: "translate(-139.526 -353.81)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505394",
    "data-name": "Path 505394",
    d: "M139.675,376.184l-.1.513C139.6,376.566,139.633,376.394,139.675,376.184Z",
    transform: "translate(-139.494 -356.116)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505395",
    "data-name": "Path 505395",
    d: "M139.493,377.157c-.011.053-.011.056,0,0Z",
    transform: "translate(-139.485 -356.216)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505396",
    "data-name": "Path 505396",
    d: "M139.864,375.188l-.177.893Z",
    transform: "translate(-139.506 -356.013)",
    fill: "#ff887c",
    opacity: 0.17
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505397",
    "data-name": "Path 505397",
    d: "M189.223,351.1a.375.375,0,0,1-.055,0l-7.927-.979a.448.448,0,1,1,.109-.89l7.5.925,4.174-26.634a.449.449,0,0,1,.887.138l-4.242,27.064A.449.449,0,0,1,189.223,351.1Z",
    transform: "translate(-141.27 -323.138)",
    fill: "#1b1b25",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505398",
    "data-name": "Path 505398",
    d: "M200.511,358.792l17.9-.448c3.339.439,8.655-2.574,8.037-5.885h0Z",
    transform: "translate(-143.297 -318.659)",
    fill: "#ff887c",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134973",
    "data-name": "Group 134973",
    transform: "translate(26.969 2.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134963",
    "data-name": "Group 134963"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505399",
    "data-name": "Path 505399",
    d: "M253.5,253.59l-6.087-41.428a45.8,45.8,0,0,0-3.835-12.771l3.305-.53s-2.32-33.627-40.035-25.6a45.846,45.846,0,0,0-11.4.248h0a33.531,33.531,0,0,0-28.3,38.049l3.548,24.15a33.532,33.532,0,0,0,38.05,28.3l41.546-6.1A3.8,3.8,0,0,0,253.5,253.59Z",
    transform: "translate(-166.791 -172.024)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505400",
    "data-name": "Path 505400",
    d: "M235.522,198.195a.449.449,0,0,1-.061-.893l12.129-1.656a.364.364,0,0,0,.243-.146.336.336,0,0,0,.061-.257c-1.961-10.932-12.031-15.975-12.133-16.025a.448.448,0,0,1,.394-.805c.106.051,10.58,5.283,12.623,16.672a1.227,1.227,0,0,1-.219.943,1.263,1.263,0,0,1-.848.508l-12.128,1.657A.468.468,0,0,1,235.522,198.195Z",
    transform: "translate(-173.828 -172.678)",
    fill: "#fcf0e3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134965",
    "data-name": "Group 134965",
    transform: "translate(15.509 21.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134964",
    "data-name": "Group 134964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505401",
    "data-name": "Path 505401",
    d: "M241.951,202.391l-33.2,5.334-8.058-11.917c1.583,13.3-8.221,21.884-8.221,21.884s-.1-.137-.274-.389l-.275.051a9.639,9.639,0,0,0-7.677,11.215h0a9.637,9.637,0,0,0,11.214,7.677l.634-.118a24.722,24.722,0,0,0,7.185,12.574v21.277a13.753,13.753,0,0,0,13.713,13.713h0A13.753,13.753,0,0,0,230.7,269.978v-16.8a24.886,24.886,0,0,0,12.181-12.214l.015-.024a24.521,24.521,0,0,0,3.059-17.136Z",
    transform: "translate(-184.082 -195.808)",
    fill: "#fec29e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505402",
    "data-name": "Path 505402",
    d: "M227.672,257.127h0a24.624,24.624,0,0,1-27.938-16.566c-.124-.381-2.29.117-2.235.35a24.717,24.717,0,0,0,7.227,12.45,13.755,13.755,0,0,0,13.648,12.449h0a13.742,13.742,0,0,0,12.146-7.388,24.86,24.86,0,0,0,13.762-12.887A24.558,24.558,0,0,1,227.672,257.127Z",
    transform: "translate(-185.465 -200.405)",
    fill: "#ff887c",
    opacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134972",
    "data-name": "Group 134972",
    transform: "translate(21.106 32.386)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505403",
    "data-name": "Path 505403",
    d: "M191.562,233a.449.449,0,0,1-.275-.8l2.982-2.314-3.807-3.592a.449.449,0,1,1,.615-.653l4.188,3.952a.449.449,0,0,1-.033.681l-3.4,2.635A.445.445,0,0,1,191.562,233Z",
    transform: "translate(-190.322 -209.922)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_134971",
    "data-name": "Group 134971",
    transform: "translate(23.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134970",
    "data-name": "Group 134970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134969",
    "data-name": "Group 134969",
    transform: "translate(1.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134968",
    "data-name": "Group 134968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134966",
    "data-name": "Group 134966",
    transform: "translate(0 3.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505404",
    "data-name": "Path 505404",
    d: "M218.267,215.234a3.153,3.153,0,0,0,1.223-.466c.41-.222.827-.434,1.2-.605s.8-.356,1.233-.527A3.136,3.136,0,0,0,223.06,213c.254-.282.2-.726-.391-1.023a3.608,3.608,0,0,0-2.946.2,3.5,3.5,0,0,0-2.018,2.113C217.564,214.931,217.884,215.249,218.267,215.234Z",
    transform: "translate(-217.671 -211.751)",
    fill: "#1b1b25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134967",
    "data-name": "Group 134967",
    transform: "translate(18.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505405",
    "data-name": "Path 505405",
    d: "M244.232,210.722a3.156,3.156,0,0,1-1.3-.109c-.456-.1-.915-.188-1.317-.252s-.867-.12-1.331-.165a3.124,3.124,0,0,1-1.272-.3c-.323-.2-.4-.641.092-1.092a3.607,3.607,0,0,1,2.887-.622,3.5,3.5,0,0,1,2.523,1.473C244.824,210.237,244.605,210.631,244.232,210.722Z",
    transform: "translate(-238.751 -208.13)",
    fill: "#1b1b25"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_505406",
    "data-name": "Path 505406",
    d: "M229.156,235.9a8.839,8.839,0,0,1-6.165-2.924.449.449,0,0,1,.689-.575c.143.17,3.547,4.146,8.3,1.951a.448.448,0,0,1,.376.814A7.567,7.567,0,0,1,229.156,235.9Z",
    transform: "translate(-216.799 -210.615)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505407",
    "data-name": "Path 505407",
    d: "M232.81,227.78a.449.449,0,0,1-.086-.889l3.155-.621a3.627,3.627,0,0,0,2.855-4.254,1.312,1.312,0,0,0-1.536-1.031,3.067,3.067,0,0,1-3.6-2.414l-.762-3.869a.448.448,0,1,1,.88-.174l.762,3.869a2.17,2.17,0,0,0,2.544,1.707,2.205,2.205,0,0,1,2.59,1.738,4.525,4.525,0,0,1-3.562,5.308l-3.155.62A.41.41,0,0,1,232.81,227.78Z",
    transform: "translate(-217.775 -208.752)",
    fill: "#fb8e77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505408",
    "data-name": "Path 505408",
    d: "M222.72,223.666h0a1.112,1.112,0,0,1-1.294-.886l-.248-1.324a1.114,1.114,0,0,1,.887-1.3h0a1.113,1.113,0,0,1,1.3.887l.248,1.323A1.113,1.113,0,0,1,222.72,223.666Z",
    transform: "translate(-216.621 -209.368)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505409",
    "data-name": "Path 505409",
    d: "M243.69,220.259h0a1.114,1.114,0,0,1-1.3-.887l-.248-1.323a1.113,1.113,0,0,1,.887-1.3h0a1.114,1.114,0,0,1,1.3.886l.248,1.324A1.114,1.114,0,0,1,243.69,220.259Z",
    transform: "translate(-218.782 -209.017)",
    fill: "#1b1b25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505410",
    "data-name": "Path 505410",
    d: "M221.415,229.33l-3.788.426a1.379,1.379,0,0,1-1.519-1.213h0a1.379,1.379,0,0,1,1.213-1.519l3.787-.425a1.377,1.377,0,0,1,1.519,1.212h0A1.378,1.378,0,0,1,221.415,229.33Z",
    transform: "translate(-216.099 -210.033)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505411",
    "data-name": "Path 505411",
    d: "M249.808,224.857l-3.788.426a1.378,1.378,0,0,1-1.519-1.212h0a1.378,1.378,0,0,1,1.213-1.519l3.787-.426a1.378,1.378,0,0,1,1.519,1.212h0A1.378,1.378,0,0,1,249.808,224.857Z",
    transform: "translate(-219.025 -209.572)",
    fill: "#ff887c",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505412",
    "data-name": "Path 505412",
    d: "M237.379,247.027a.443.443,0,0,1-.264-.086,3.26,3.26,0,0,0-3.675.005.449.449,0,0,1-.515-.735,4.136,4.136,0,0,1,4.718,0,.449.449,0,0,1-.265.811Z",
    transform: "translate(-217.814 -211.978)",
    fill: "#fb8e77"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "NoPath",
    d: "M0,0,43.993.118V14L0,14.119Z",
    transform: "translate(744.066 4266.941)",
    fill: "url(#pattern)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.dd4361130f9e2c91955e365e5505ec06.svg";
export { ForwardRef as ReactComponent };